import React from 'react';
import { Box, CardMedia, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(({ spacing }) => ({
    card: {
        borderRadius: "5px",
        boxShadow: "10px 4px 20px rgba(0, 0, 0, 0.09)",
        position: "relative",
    },
    cardContent: {
        backgroundColor: "white",
        borderRadius: "0 0 5px 5px",
    },
    title: {
        fontWeight: "bold",
        fontSize: "24px",
        lineHeight: "30px",
        backgroundColor: "white",
        width: "80%",
        margin: "0 5%",
        padding: "0 5%",
        borderRadius: "5px",
        position: "absolute",
        bottom: "21%",
    },
    description: {
        fontWeight: 300,
        fontSize: "12px",
        lineHeight: "15px",
        padding: "6% 10%"
    },
}));

const GiftCard = (props) => {
    const classes = useStyles();

    return (
        <Box className={classes.card} component="div">
            <CardMedia component="img" image={props.info.img} />
            <Box component="div" className={classes.cardContent} >
                <Typography className={classes.title} variant="h6">{props.info.title}</Typography>
                <Typography className={classes.description} p="true" >{props.info.description}</Typography>
            </Box>
        </Box>
    )
}

export default GiftCard;
